export default __webpack_public_path__ + "static/media/Note-Taker.26008c63.jpeg";